export class PAFormQuestionModel {
    constructor() {
        this.id = "";
        this.question = "";
        this.listOrder = 0;
        this.formId = "";
        this.controlTypeId = "";
        this.isMandatory = false;
        this.isSaved = false;
    }
}
export default class FormDesign extends PAFormQuestionModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
